module.exports = __webpack_public_path__ + "img/square_shape.e4c218a3.svg";